import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { orgAdmin } from "../api";

const BranchContext = createContext(null);

/**
 * Wraps the branch-management routes.
 * Provides the branch's facility ID + name to all child pages,
 * so the existing facility admin pages can be reused without modification.
 */
export function BranchProvider({ branchId, children }) {
  const [branch,  setBranch]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const load = useCallback(async () => {
    if (!branchId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await orgAdmin.getBranch(branchId);
      setBranch(res.data);
    } catch {
      setError("Failed to load branch.");
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => { load(); }, [load]);

  return (
    <BranchContext.Provider value={{ branch, branchId, loading, error, reload: load }}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  const ctx = useContext(BranchContext);
  if (!ctx) throw new Error("useBranch must be used within BranchProvider");
  return ctx;
}
